













































import Vue from "vue";
import axios from "axios";
import { GameStateResponse } from "../models/game_state";
import uniqueIdGenerator from "../util/uniqueIdGenerator";

interface PlayerRegistrationResp {
  assigned_number: number;
}

export default Vue.extend({
  name: "Lobby",
  props: {
    routed: String,
  },
  data() {
    return {
      gameid: uniqueIdGenerator(),
      playerNumber: -1,
      gameFull: false,
      playerOptions: [1, 2, 3, 4]
    };
  },
  watch: {
    playerNumber: function(val) {
      this.$emit("registered", val);
    }
  },
  mounted() {
    if (this.routed) {
      this.gameid = this.routed;
      this.enterGame();
    }
  },
  methods: {
    enterGame() {
      axios
        .get<GameStateResponse>(
          `${process.env.VUE_APP_BACKEND_URL}/game_state?game_id=${this.gameid}`
        )
        .then(response => {
          this.$emit("change", response.data.id);
          axios
            .post<PlayerRegistrationResp>(
              `${process.env.VUE_APP_BACKEND_URL}/player?game_id=${this.gameid}`
            )
            .then(
              response => {
                // updating player number will close lobby
                this.$emit("registered", response.data.assigned_number);
              }
            )
            .catch(error => {
              console.log(error);
              this.gameFull = true;
            });
        });
    }
  }
});
